module.exports = __webpack_public_path__ + "img/hand.93079f92.svg";